import DE_OFFLINE_OVERLAY_PAGE_CONSTANTS from './de'
import EN_OFFLINE_OVERLAY_PAGE_CONSTANTS from './en'
import FR_OFFLINE_OVERLAY_PAGE_CONSTANTS from './fr'
import HU_OFFLINE_OVERLAY_PAGE_CONSTANTS from './hu'
import { T_OFFLINE_OVERLAY_PAGE_CONSTANTS } from './TYPES'

import { T_GENERIC_LANGUAGE_MAP } from '~/src/Constants/LANGUAGE'

import objectPathFactory from '~/src/Lib/objectPathFactory'

const OFFLINE_OVERLAY_PAGE_CONSTANTS: T_GENERIC_LANGUAGE_MAP<T_OFFLINE_OVERLAY_PAGE_CONSTANTS> =
  {
    hu: HU_OFFLINE_OVERLAY_PAGE_CONSTANTS,
    en: EN_OFFLINE_OVERLAY_PAGE_CONSTANTS,
    fr: FR_OFFLINE_OVERLAY_PAGE_CONSTANTS,
    de: DE_OFFLINE_OVERLAY_PAGE_CONSTANTS
  }

export default OFFLINE_OVERLAY_PAGE_CONSTANTS

export const OFFLINE_OVERLAY_PAGE_CONSTANTS_PATH =
  objectPathFactory<T_OFFLINE_OVERLAY_PAGE_CONSTANTS>()
